import { post } from '../../common/services/api.service';
import { API_URL, LOGIN_ENDPOINT } from '../../constants/api';

/**
 * Class representing the authentication service.
 * */
class AuthenticationService {

  /**
   * Makes the login call.
   * @param {string} username - The username.
   * @param {string} password - The password.
   * @return {object} Promise - The http call promise.
   * */
  login = (username, password) => post(`${API_URL}${LOGIN_ENDPOINT}`, null, {
    user_email: username,
    user_password: password
  });

}

export default new AuthenticationService();



// WEBPACK FOOTER //
// ./src/messages/services/authentication.service.js